import React, { FC } from 'react'
const BuildingBlocksIcon: FC<{
    className?: string
}> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 1680 1080"
        {...props}
    >
        <defs>
            <linearGradient
                id="linear-gradient"
                x1={582.1}
                x2={582.1}
                y1={1157.6}
                y2={1224.3}
                gradientTransform="matrix(1 0 0 -1 564 1316)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="gray" stopOpacity={0.2} />
                <stop offset={0.5} stopColor="gray" stopOpacity={0.1} />
                <stop offset={1} stopColor="gray" stopOpacity={0.1} />
            </linearGradient>
            <linearGradient
                xlinkHref="#linear-gradient"
                id="linear-gradient-2"
                x1={707.5}
                x2={707.5}
                y1={-661744}
                y2={-112891.5}
            />
            <clipPath id="clippath">
                <path
                    d="M53.5 50.1h1572.6v980H53.5z"
                    style={{
                        fill: 'none',
                        strokeWidth: 0,
                    }}
                />
            </clipPath>
            <style>
                {
                    '.cls-11,.cls-12,.cls-13,.cls-14,.cls-16,.cls-3,.cls-5,.cls-6,.cls-9{stroke-width:0}.cls-18{fill:none}.cls-3{fill:#575988}.cls-5{fill:#33acde}.cls-6{fill:#fff;opacity:.5}.cls-16,.cls-6,.cls-9{isolation:isolate}.cls-16{opacity:.2}.cls-18{stroke:#535461;stroke-miterlimit:10}.cls-9{opacity:.1}.cls-16,.cls-9{fill:#000}.cls-11{fill:#e14b5a}.cls-12{fill:#a8a8a8}.cls-13{fill:#f7c4a7}.cls-14{fill:#535461}'
                }
            </style>
        </defs>
        <g
            style={{
                clipPath: 'url(#clippath)',
            }}
        >
            <path
                d="M438.2 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M749.6 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1061 666.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 666.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1087.7 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M776.3 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M464.9 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 666.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V653c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M438.2 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M749.6 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1061 542.5H932c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 542.5h-129c-7.4 0-13.4 6-13.4 13.3V591c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1087.7 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M776.3 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M464.9 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 542.5h129c7.4 0 13.4-6 13.4-13.3V494c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M438.2 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M749.6 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1061 421.7H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 421.7h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3V435c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1087.7 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M776.3 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M464.9 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 421.7h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M438.2 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M593.9 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M749.6 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M905.3 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1061 297.9H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
            <path
                d="M1216.7 297.9h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-9"
            />
            <path
                d="M1216.7 91.7h-141.1c-7.4 0-13.4 6-13.4 13.3v40c0 7.4 6 13.3 13.4 13.3h141.1c7.4 0 13.4-6 13.4-13.3v-40c0-7.4-6-13.3-13.4-13.3Z"
                style={{
                    fill: 'url(#linear-gradient)',
                    strokeWidth: 0,
                }}
            />
            <path
                d="M1081.6 156h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3ZM932 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M932 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3H932c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M776.3 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M620.6 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M464.9 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M309.2 297.9h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M807.8 1030.1c416.6 0 754.3-76.7 754.3-171.3s-337.7-171.3-754.3-171.3S53.5 764.1 53.5 858.7 391.2 1030 807.8 1030Z"
                style={{
                    fill: '#f5f5f5',
                    strokeWidth: 0,
                }}
            />
            <path
                d="M225.7 781.8s13.6-45.9-2.5-79.7c-6.8-14.1-8.9-30.1-5.9-45.5 1.5-7.3 3.7-14.5 6.5-21.4"
                style={{
                    strokeWidth: 2,
                    stroke: '#535461',
                    strokeMiterlimit: 10,
                    fill: 'none',
                }}
            />
            <path
                d="M213.8 613.9c0 5.6 10.2 22 10.2 22s10.2-16.3 10.2-22-1.1-5.3-3-7.2c-1.9-1.9-4.5-3-7.2-3s-5.3 1.1-7.2 3c-1.9 1.9-3 4.5-3 7.2ZM196.9 645.1c3 4.7 20.5 12.9 20.5 12.9s-.3-19.2-3.4-24c-1.5-2.3-3.8-3.8-6.4-4.4-2.6-.6-5.4 0-7.7 1.4-2.3 1.5-3.9 3.8-4.4 6.4-.6 2.6 0 5.4 1.4 7.6ZM197.6 698.4c5 2.5 24.2.8 24.2.8s-10-16.4-15-19c-2.4-1.1-5.2-1.3-7.7-.5-2.5.9-4.6 2.7-5.8 5.1-1.2 2.4-1.4 5.1-.6 7.7s2.6 4.7 4.9 5.9ZM207.3 738.5c4.5 3.4 23.7 4.9 23.7 4.9s-7.1-17.9-11.6-21.2c-2.2-1.4-4.8-2-7.4-1.5-2.6.5-4.9 1.9-6.4 4s-2.2 4.7-1.9 7.3c.3 2.6 1.6 5 3.6 6.6ZM238.8 659.1c-4 3.9-22.9 8-22.9 8s4.6-18.7 8.6-22.6c1-.9 2.1-1.7 3.3-2.2s2.6-.7 3.9-.7c1.3 0 2.7.3 3.9.8 1.2.5 2.3 1.3 3.3 2.3.9 1 1.7 2.1 2.2 3.3.5 1.2.7 2.6.7 3.9 0 1.3-.3 2.7-.8 3.9-.5 1.2-1.3 2.3-2.3 3.3ZM249.5 706.1c-5 2.5-24.2.8-24.2.8s10-16.4 15-19c2.4-1.1 5.1-1.2 7.6-.3 2.5.9 4.5 2.7 5.7 5s1.4 5.1.6 7.6c-.8 2.5-2.5 4.6-4.8 5.9ZM253.6 753.4c-4.5 3.4-23.7 4.9-23.7 4.9s7.1-17.9 11.6-21.2c2.2-1.4 4.8-2 7.4-1.5 2.6.5 4.9 1.9 6.4 4s2.2 4.7 1.9 7.3c-.3 2.6-1.6 5-3.6 6.6ZM955.9 521.7s49.7 49.7 21.6 123.3c-28.1 73.7 48.1 196.3 48.1 196.3s-.8-.1-2.3-.4c-102.1-18.1-152.8-134.7-96.1-221.3 21.1-32.2 38.4-70 28.6-97.9Z"
                className="cls-5"
            />
            <path
                d="M955.9 521.7s49.7 49.7 21.6 123.3c-28.1 73.7 48.1 196.3 48.1 196.3s-.8-.1-2.3-.4c-102.1-18.1-152.8-134.7-96.1-221.3 21.1-32.2 38.4-70 28.6-97.9Z"
                className="cls-16"
            />
            <path
                d="M955.9 521.7s28.1 60.9 0 110.5c-28.1 49.7-4.8 189 69.8 209"
                className="cls-18"
            />
            <path
                d="M867.4 722.5s56.7-9.1 61.9 41.8c5.2 50.8 109.1 57.8 109.1 57.8l-1.9 1.3c-85.8 56.3-167.8 35.8-155.5-38.9 4.6-27.8 4.2-55.7-13.6-62Z"
                className="cls-5"
            />
            <path
                d="M867.4 722.5s56.7-9.1 61.9 41.8c5.2 50.8 109.1 57.8 109.1 57.8l-1.9 1.3c-85.8 56.3-167.8 35.8-155.5-38.9 4.6-27.8 4.2-55.7-13.6-62Z"
                style={{
                    opacity: 0.2,
                    isolation: 'isolate',
                    fill: '#f5f5f5',
                    strokeWidth: 0,
                }}
            />
            <path
                d="M867.4 722.5s44 9.6 40.4 49.6c-3.6 40 65.4 87.9 130.6 49.9"
                className="cls-18"
            />
            <path
                d="M1299 839.3s-84.2-16.8-106.7-39.3c-22.5-22.4-123.5-61.7-134.7-33.6-11.2 28-151.6 123.4-56.1 140.2 95.5 16.8 224.5 22.4 252.6 11.2 28.1-11.2 44.8-78.5 44.8-78.5Z"
                className="cls-12"
            />
            <path
                d="M1001.5 896.2c95.4 16.8 224.5 22.4 252.6 11.2 21.4-8.5 36.3-49.6 42.1-68.7l2.8.6s-16.8 67.3-44.9 78.5c-28.1 11.2-157.2 5.6-252.6-11.2-27.5-4.9-35.4-16.3-32.5-30.7 2.2 9.4 11.9 16.6 32.5 20.3Z"
                className="cls-16"
            />
            <path
                d="M1469.3 92.6c-1.5-3.7-3.9-7-7-9.6-22.6-20.6-59.1-14.3-87.2-26.9-6.5-2.9-13.1-6.9-20.1-5.8-9.8 1.5-18.9 12.7-27.5 7.7l.6 1.9-.6-.3 6.3 19.1c2.4 7.3 5 14.9 9.6 21-6.9 6-12.2 13.7-15.4 22.3-3.2 8.6-4.2 17.9-2.9 27 1.3 9.1 4.9 17.7 10.4 25.1 5.5 7.4 12.8 13.2 21.2 17 .3.6.6 1.3.9 1.9l.8.3c1.9 4.3 3.2 8.7 4.1 13.3-7.3 1-20 9.1-32.4 20.9l-24.9-.8c-16.1-.5-31.7-5.8-44.8-15.2l-74.6-53.5c-5.3.5-10.3 2.7-14.3 6.3-9.2-9.6-17.1-19.6-16.4-25.7 0 0-34.7-64.8-47.3-32.4-12.6 32.4 23.6 66.4 23.6 66.4l23 29.8c-.9 5.2-1.5 10.5-1.7 15.8 28.4 32.4 127.7 61.7 127.7 61.7l15.5.8v.8c-.9 4.1-1.3 8.2-1.3 12.4v3.1c.8 51.7 7.9 209.8 7.9 209.8 1.4-.6 2.8-1.2 4.3-1.7l-1.1 14.1s-66.2 9.3-115 27.8c-48.9 18.5-50.4 40.1-50.4 40.1v190.6c-14 7.2-36 16.6-47.3 11.5-12.3-5.5-19-.9-20.2 3.9-.2.9-.2 1.9 0 2.9.1.4.3.8.5 1.2.2.5.5.9.8 1.2 4.7 4.6 107.2 44.7 130.8 38.6.7-.2 1.4-.4 2.1-.7.2 0 .4-.2.7-.3.2-.1.9-.4 1.3-.6.4-.2.5-.3.7-.5.2-.2.7-.5 1-.7l.6-.6c.2-.2.6-.5.9-.8.3-.3.4-.5.6-.7.2-.2.5-.6.8-.9.2-.3.3-.5.5-.7.2-.2.5-.7.7-1.1.2-.4.3-.5.4-.8.1-.3.4-.8.6-1.2.2-.4.2-.5.3-.8.1-.3.4-.9.5-1.3.2-.4.2-.5.3-.8.1-.3.3-1 .5-1.5 0-.3.1-.5.2-.8.1-.5.3-1 .4-1.5 0-.2.1-.5.2-.7.1-.6.2-1.1.3-1.7 0-.2 0-.4.1-.6.1-.6.2-1.3.3-1.9v-.5c0-.7.1-1.4.2-2v-.4c0-.7.1-1.5.1-2.2V808c0-9.4-1-18.5-3-27.5l5.9-162.3c31 .5 61.9-.7 92.8-3.4l3.4 77.5s0 50.9 17.3 74.1c14.8 19.8 32 107.4 36.6 132.3-6.4 12.1-18.6 27.2-39.8 26.7 0 0-39.9-3.4-37.7 7.5 0 .3.1.6.3.8.1.3.3.6.4.9.2.3.3.6.6.9v.2c.3.3.6.6.9 1 .3.4.6.7.9 1l.3.3 1.1 1.1c20.5 18.5 140.3 21.6 140.3 21.6v-.9c0-5.4-.8-33.5-8-54.6h1.7s-17.3-155.9-31.5-174.4c0 0-3.8-82.2 4.7-133.7l1.5-.6c39.7-14.8 42.6-51.3 38.5-78.1 7.6 2.4 12 4.1 12 4.1s-.1-1.2-.4-3.2l.4.2s-.8-4.9-2-12.5c-2.8-21-8.3-57.8-14.2-75.1-1-3.8-1.9-7.1-2.7-9.5-3.4-10.4-5.7-21.2-6.9-32-1.6-14.1-2.4-28.3-2.4-42.5.1-19 1.6-37.9 4.4-56.7 2.4-16.4 4.5-35.1 4.4-48.1.2-4.5-.2-9.1-1-13.6-2.1-9.6-11.4-15.9-21.1-19.9-.6-.3-1.3-.5-1.9-.7.2-3.6.5-7.8.9-12.1 1.2.8 2.5 1.4 3.8 1.6s2.8.3 4.2 0c4.2-.9 7.1-4.4 9.8-7.5 14-17.1 28.3-35 33.7-56.3 2.2-9.5 3.2-19.2 3-29V104c.3-3.6-.1-7.3-1.1-10.8Z"
                style={{
                    fill: 'url(#linear-gradient-2)',
                    strokeWidth: 0,
                }}
            />
            <path
                d="M1342.1 176.1s21.2 31.7 16.6 46.8c-4.5 15.1 49.9 6 49.9 6s1.5-58.9 12.1-72.5c10.6-13.6-78.6 19.6-78.6 19.6ZM1202.3 196.5s-43.8-36.2-42.3-49.8c0 0-33.3-63.4-45.3-31.7-12.1 31.7 22.7 64.9 22.7 64.9l42.3 55.9 22.7-39.3Z"
                className="cls-13"
            />
            <path
                d="M1157.7 764.9s-40.8 25.7-57.4 18.1c-16.6-7.5-22.7 4.5-18.1 9.1s102.8 43.8 125.5 37.7c22.7-6 11.1-55.5 11.1-55.5l-61-9.4ZM1373.9 875.1s-9.8 41.5-43.8 40.8c0 0-51.4-4.5-31.7 13.6s134.5 21.1 134.5 21.1 0-61.9-21.2-75.5c-21.2-13.6-37.8 0-37.8 0Z"
                className="cls-14"
            />
            <path
                d="m1311.9 582.2 4.5 105.7s0 49.8 16.6 72.5c16.6 22.6 36.3 135.9 36.3 135.9h57.4s-16.6-152.5-30.2-170.6c0 0-6-134.4 15.1-164.6l-99.8 21.1Z"
                className="cls-3"
            />
            <path
                d="m1311.9 582.2 4.5 105.7s0 49.8 16.6 72.5c16.6 22.6 36.3 135.9 36.3 135.9h57.4s-16.6-152.5-30.2-170.6c0 0-6-134.4 15.1-164.6l-99.8 21.1Z"
                className="cls-9"
            />
            <path
                d="M1431.3 487.1s34.8 83-28.7 107.2c-63.5 24.2-178.4 21.1-178.4 21.1l-6 175.1s-71 9.1-72.6-13.6V585.2s1.5-21.1 48.4-39.3c46.9-18.1 110.3-27.2 110.3-27.2l3-39.3 124 7.5Z"
                className="cls-3"
            />
            <path
                d="M1375.6 213.6c12.1-1.3 24.3.4 35.5 5 9.3 3.9 18.1 10 20.2 19.4 2.4 11.1-.3 36.1-3.3 57.3-4.9 33.1-5.5 66.8-1.8 100.1 1.5 13.9 3.7 26 6.7 31.4 9.1 16.6 18.1 95.1 18.1 95.1s-99.8-37.7-149.6-15.1c0 0-6.8-154.7-7.6-205.3-.6-39.2 49.1-83.8 65.8-85.3 9.7-.9 6.4-1.5 16.1-2.5Z"
                className="cls-9"
            />
            <path
                d="M1375.6 210.6c12.1-1.3 24.3.4 35.5 5 9.3 3.9 18.1 10 20.2 19.4 2.4 11.1-.3 36.1-3.3 57.3-4.9 33.1-5.5 66.8-1.8 100.1 1.2 10.6 3.4 21.1 6.7 31.4 6.8 20.4 18.1 95.1 18.1 95.1s-99.8-37.7-149.6-15.1c0 0-6.8-154.7-7.6-205.3-.6-39.2 49.1-83.8 65.8-85.3 9.7-.9 6.4-1.5 16.1-2.5Z"
                className="cls-11"
            />
            <path
                d="m1402.6 293.9-107.3-6s-6.8-52.6 8.7-52l106.2 3.7s22.7 27.2-7.6 54.3Z"
                className="cls-9"
            />
            <path
                d="m1402.6 290.9-122.4-6s-95.2-28.7-122.4-60.4c0 0 1.5-55.9 31.7-58.9L1261 218c12.5 9.2 27.5 14.3 43 14.9l106.2 3.7s22.7 27.2-7.6 54.3Z"
                className="cls-11"
            />
            <path
                d="M1407.9 182.9c1.8-14.3 8.3-19.1 12.8-24.9 10.6-13.6-78.6 19.6-78.6 19.6 4.6 7.1 8.7 14.5 12.1 22.2 7.1 3.3 14.8 5 22.7 5 13.1 0 21.6-14.1 31-21.9Z"
                className="cls-9"
            />
            <path
                d="M1376.9 203.3c30.1 0 54.4-24.3 54.4-54.3s-24.4-54.3-54.4-54.3-54.4 24.3-54.4 54.3 24.4 54.3 54.4 54.3Z"
                className="cls-13"
            />
            <path
                d="M1342.6 110.9c-5.8-6.3-8.6-14.7-11.2-22.9l-6-18.7c8.2 4.8 16.9-6 26.3-7.5 6.7-1.1 13.1 2.9 19.3 5.7 26.9 12.3 62 6.2 83.6 26.3 3 2.6 5.3 5.8 6.7 9.4 1 3.4 1.4 7 1.2 10.6.2 9.5-.8 19-2.8 28.4-5.1 20.8-18.9 38.3-32.3 55.1-2.5 3.2-5.4 6.6-9.4 7.5-7.8 1.7-13.8-6.7-16.8-14-4-9.8-6.9-19.9-8.8-30.3-.8-4.4-1.4-8.9-3.6-12.8-4.7-8.3-16.2-16.1-23.2-22.6-7-6.4-16.5-7-22.9-14Z"
                className="cls-9"
            />
            <path
                d="M1342.6 109.4c-5.8-6.3-8.6-14.7-11.2-22.9l-6-18.7c8.2 4.8 16.9-6 26.3-7.5 6.7-1.1 13.1 2.9 19.3 5.7 26.9 12.3 62 6.2 83.6 26.3 3 2.6 5.3 5.8 6.7 9.4 1 3.4 1.4 7 1.2 10.6.2 9.5-.8 19-2.8 28.4-5.1 20.8-18.9 38.3-32.3 55.1-2.5 3.2-5.4 6.6-9.4 7.5-7.8 1.7-13.8-6.7-16.8-14-4-9.8-6.9-19.9-8.8-30.3-.8-4.4-1.4-8.9-3.6-12.8-4.7-8.3-16.2-16.1-23.2-22.6-7-6.4-16.5-7-22.9-14Z"
                style={{
                    fill: '#632652',
                    strokeWidth: 0,
                }}
            />
            <path
                d="M1391.3 164.8c2.5 0 4.5-4.4 4.5-9.8s-2-9.8-4.5-9.8-4.5 4.4-4.5 9.8 2 9.8 4.5 9.8Z"
                className="cls-13"
            />
            <path
                d="M1418.5 416.9s-3 9.1-18.1 7.5c-15.1-1.5-59-4.5-59 0"
                className="cls-9"
            />
            <path
                d="M1298.3 927.9c-2.7-2.5-4.1-4.5-4.4-6.3-.4 2 .8 4.5 4.4 7.8 19.7 18.1 134.5 21.1 134.5 21.1V949c-.7 0-114.9-3.1-134.5-21.1ZM1207.6 826.8c-22.7 6-120.9-33.2-125.5-37.7-.6-.6-1-1.4-1.3-2.2-.3.9-.3 1.9 0 2.8.2.9.7 1.8 1.3 2.5 4.5 4.5 102.8 43.8 125.5 37.7 11.7-3.1 14.3-17.7 14.1-31.2-.2 12.5-3.3 25.2-14.1 28.1Z"
                className="cls-6"
            />
            <path
                d="M812.5 810.6c.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.6s-.2-1.2-.7-1.6-1-.7-1.6-.7-1.2.2-1.6.7c-.4.4-.7 1-.7 1.6s.2 1.2.7 1.6c.4.4 1 .7 1.6.7Z"
                style={{
                    fill: '#67647e',
                    strokeWidth: 0,
                }}
            />
            <path
                d="M191.8 770.5s56.4-1.7 73.4-13.8c17-12.1 86.8-26.5 91-7.1 4.2 19.4 84.8 96.4 21 97-63.7.6-148-9.9-164.9-20.2-17-10.3-20.5-55.8-20.5-55.8Z"
                className="cls-12"
            />
            <path
                d="M378.4 839.7c-63.7.5-148-9.9-164.9-20.2-12.9-7.9-18.1-36.1-19.8-49.1h-1.9s3.6 45.4 20.5 55.8c17 10.3 101.3 20.8 164.9 20.4 18.4-.1 24.7-6.7 24.4-16.3-2.5 5.8-9.5 9.4-23.2 9.5Z"
                className="cls-16"
            />
            <path
                d="M1483.7 915.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V902c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M1483.7 915.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3V902c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M1612.7 794.6h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3ZM1483.7 794.6h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-5"
            />
            <path
                d="M1483.7 794.6h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3Z"
                className="cls-9"
            />
            <path
                d="M1612.7 670.8h-129c-7.4 0-13.4 6-13.4 13.3v35.2c0 7.4 6 13.3 13.4 13.3h129c7.4 0 13.4-6 13.4-13.3v-35.2c0-7.4-6-13.3-13.4-13.3Z"
                className="cls-5"
            />
        </g>
    </svg>
)
export default BuildingBlocksIcon
